import {useFluxStore} from 'client/framework';

import type {QueryBuilder} from '@albert-io/json-api-framework/request/builder';
import {getUserQuery} from 'client/Clever/util';
import type {CleverUser} from 'client/Clever/util';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';
import useAreLatestQueriesReady from 'lib/hooks/useAreLatestQueriesReady';

interface CleverUserResult {
  user: CleverUser | null;
  showClever: boolean;
}

/**
 * The current teacher's Clever profile + whether Clever sync should be offered.
 */
export const useCleverUser = (): CleverUserResult => {
  const isMasquerading = useFluxStore(masqueradeStore, (s) => s.isMasquerading());
  const {isReady} = useAreLatestQueriesReady(
    isMasquerading ? [] : [() => getUserQuery() as unknown as QueryBuilder]
  );
  // Bridged so the read re-runs on state-tree emits — a bare render read would be frozen by
  // the React Compiler.
  const userResource = useFluxStore(masqueradeStore, () =>
    isMasquerading ? null : getUserQuery().getResource()
  );
  const user = !isMasquerading && isReady ? (userResource as unknown as CleverUser) : null;
  const showClever = Boolean(user?.getMeta().isAllowCleverSync());

  return {user, showClever};
};
